// @flow
import { background } from '../stylesheets/background.css'
import videoStyles from '../stylesheets/video.css'
import { trackAction } from '../utils/googleAnalytics'
import { getOverlayElement } from '../utils/renderUtils'

type videoType = {
  mp4: string,
  webm: string,
  poster: string,
  subtitles: ?Object
}

type videoHandlerTypeProps = {
  video: videoType,
  alignment: ?Array<string>
}

const bgVideos = []

export const videoComponent = {
  type: 'video',
  render(id: string, props: videoHandlerTypeProps, bgInnerHTML: ?string = '') {
    const { video, alignment, overlay } = props
    const { mp4, webm, poster, subtitles, hasSound } = video

    const trackElement = subtitles ?
      `<track src="${
          subtitles
        }" kind="caption" srclang="no" label="Norwegian" default="" />` :
      ''

    const alignmentClasses = alignment.join(' ')

    return `
      <div id="${id}" class="${background} ${videoStyles.hidePlay}" >
        <video
          muted
          loop
          preload="none"
          poster="${poster}"
          playsinline
          webkit-playsinline
          aria-hidden="true"
          class="${videoStyles.video} ${alignmentClasses}">
          <source type="video/webm" src="${webm}">
          <source type="video/mp4" src="${mp4}">
          ${trackElement}
          Your browser does not support the video tag. We suggest you upgrade your browser.
        </video>
        <div class="${videoStyles['subtitlescontainer']}"></div>
        ${bgInnerHTML}
        ${getOverlayElement(overlay)}
        
      </div>
    `
  },

  onCurrentChanged(currentSection, dispatch) {
    const { id, type, props, backgroundElement } = currentSection
    const { video } = props

    dispatch({ type: 'showMuteButton', value: video && video.hasSound })

    try {
      bgVideos.forEach(v => {
        v.pause()
      })
    } catch (error) {
      console.error('error in pause', error)
    }

    if (type === 'video') {
      const bgVideo = backgroundElement.querySelector('video')
      if (!bgVideo) return

      try {
        bgVideo.play().catch(console.error)
      } catch (error) {
        console.error('error while playing', error)
      }

      if (!bgVideo.paused) {
        trackAction(`VIDEO_PLAYING/${id}`)
      }

      if (bgVideos.indexOf(bgVideo) === -1) {
        bgVideos.push(bgVideo)
      }
    }
  },

  onStateChanged(state) {
    if (state.muted) {
      bgVideos.forEach(v => (v.muted = true))
    } else {
      bgVideos.forEach(v => (v.muted = false))
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/video.js